import { Icon } from "@opendash/icons";
import { Avatar, Card, List, Typography } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { Message } from "../../../js/parsegenerated";

type Props = {
  message: Message;
};

export default observer((props: Props) => {
  const { Title } = Typography;

  return (
    <Card style={{ marginBottom: 16 }}>
      <Title level={4}>{props.message.get("title")}</Title>
      <List
        dataSource={[props.message]}
        renderItem={(message) => (
          <List.Item>
            <List.Item.Meta
              description={message.get("content")}
              avatar={
                <Avatar
                  style={{
                    background: "--var-color-primary",
                    verticalAlign: "middle",
                  }}
                  icon={
                    <Icon
                      icon={
                        message.data?.type === "userinput"
                          ? "fa:user"
                          : message.data?.type === "media"
                            ? "fa:image"
                            : "fa:right"
                      }
                    />
                  }
                />
              }
            />
          </List.Item>
        )}
      />
    </Card>
  );
});
